import React, { useEffect, useState } from "react";
import Select from "react-select";
import { DropDownStylesBroker } from "../../../helpers/helper";
import classNames from "classnames";
import socket from "../../../socket";
import { update_form_data } from "../../../Redux/features/OrderSection/OrderSectionSlice";
import { useAppDispatch, useAppSelector } from "../../../Redux/app/hooks";
import { Provider } from "react-redux";

type Props = {
  contracts: any[];
  setConValue: any;
  onClose: any;
  iex_symbol?: string;
  nearPrice?: number | string;
};

const OptionSelector = ({ iex_symbol = "", contracts = [], setConValue, onClose, nearPrice }: Props) => {
  const [selectedExchange, setSelectedExchange] = useState(contracts[0]);
  const [selectedStrike, setSelectedStrike] = useState<{ value: string | number; label: string | number } | null>({ value: "", label: "" });
  const [selectedExpiry, setSelectedExpiry] = useState<{ value: string | number; label: string | number } | null>({ value: "", label: "" });
  const [optionType, setOptionType] = useState("CALL");

  const dispatch = useAppDispatch();

  const getNearestStrikes = (strikes: (string | number)[], near: number | string, count = 10): string[] => {
    if (!near || !strikes.length) return strikes.map((s) => String(s));

    const parsed = strikes
      .map((s) => ({
        original: String(s), // Keep original for display
        numeric: parseFloat(String(s)),
      }))
      .filter((s) => !isNaN(s.numeric)); // skip NaN values

    const sorted = parsed
      .sort((a, b) => Math.abs(a.numeric - Number(near)) - Math.abs(b.numeric - Number(near)))
      .slice(0, count)
      .sort((a, b) => a.numeric - b.numeric);

    return sorted.map((s) => s.original);
  };

  useEffect(() => {
    const nearestStrike = getNearestStrikes(selectedExchange?.Strikes || [], nearPrice ?? 0, 1)[0];
    setSelectedStrike({ value: nearestStrike, label: nearestStrike });
    setSelectedExpiry({
      value: selectedExchange?.Expirations?.[0],
      label: selectedExchange?.Expirations?.[0],
    });
  }, [selectedExchange, nearPrice]);

  const exchangeOptions = contracts.map((opt) => ({
    value: opt.Exchange,
    label: opt.Exchange,
  }));
  const expiryOptions = selectedExchange?.Expirations?.map((e: string) => ({
    value: e,
    label: e,
  }));

  const handleSelectFuture = (contract: any) => {
    var securitySet = {
      security_list: [
        {
          conid: contract?.ContractId,
          currency: contract?.Currency,
          exch: contract?.Exchange,
          isin_code: contract?.DisplaySecurity,
          market_id: 7,
          security_id: contract?.ContractId,
        },
      ],
      socket_id: socket.id,
      from: "web",
      user_id: localStorage.getItem("login-id"),
    };
    //socket.emit("security_subscription", securitySet);
  };

  const data = useAppSelector((state) => state.dashBoard.futoptData);

  return (
    <>
      {contracts.length ? (
        <div className="p-4 flex flex-col gap-2 w-[480px] mx-auto">
          <div className="flex gap-4 w-full">
            <div className="order-form-select-input w-full custome-select select-disabled">
              <label className="select-lable">Exchange</label>
              <Select
                options={exchangeOptions}
                value={{ value: selectedExchange.Exchange, label: selectedExchange.Exchange }}
                onChange={(e) => {
                  const found = contracts.find((opt) => opt.Exchange === e?.value);
                  if (found) setSelectedExchange(found);
                }}
                placeholder="Select Exchange"
                styles={{
                  ...DropDownStylesBroker,
                  indicatorSeparator: (provided: any) => ({
                    ...provided,
                    display: "none",
                  }),
                  dropdownIndicator: (base: any) => ({
                    ...base,
                    color: "inherit",
                    padding: "0",
                    minHeight: "auto",
                    maxHeight: "auto",
                    "&:hover": {
                      color: "inherit",
                    },
                  }),
                  indicatorsContainer: (provided: any) => ({
                    ...provided,
                  }),
                  menuList: (base: any) => ({
                    ...base,
                    padding: 0,
                    backgroundColor: "var(--color-white)",
                    boxShadow: "0px 3px 6px rgba(var(--color-black-rgb), 0.25) !important",
                    border: "none",
                    color: "var(--primaryText)",
                    borderRadius: 0,
                    cursor: "pointer",
                    maxHeight: "80px",
                    overflowY: "auto",
                  }),
                }}
              />
            </div>
            <div className="order-form-select-input w-full custome-select select-disabled">
              <label className="select-lable">Strike Price</label>
              <Select
                options={selectedExchange?.Strikes.map((e: any) => {
                  return { label: e, value: e };
                })}
                value={selectedStrike}
                onChange={setSelectedStrike}
                placeholder="Select Strike Price"
                styles={{
                  ...DropDownStylesBroker,
                  ...DropDownStylesBroker,
                  indicatorSeparator: (provided: any) => ({
                    ...provided,
                    display: "none",
                  }),
                  dropdownIndicator: (base: any) => ({
                    ...base,
                    color: "inherit",
                    padding: "0",
                    minHeight: "auto",
                    maxHeight: "auto",
                    "&:hover": {
                      color: "inherit",
                    },
                  }),
                  indicatorsContainer: (provided: any) => ({
                    ...provided,
                  }),
                  menuList: (base: any) => ({
                    ...base,
                    padding: 0,
                    backgroundColor: "var(--color-white)",
                    boxShadow: "0px 3px 6px rgba(var(--color-black-rgb), 0.25) !important",
                    border: "none",
                    color: "var(--primaryText)",
                    borderRadius: 0,
                    cursor: "pointer",
                    maxHeight: "80px",
                    overflowY: "auto",
                  }),
                }}
              />
            </div>
            <div className="order-form-select-input w-full custome-select select-disabled">
              <label className="select-lable">Expiry</label>
              <Select
                options={expiryOptions}
                value={selectedExpiry}
                onChange={setSelectedExpiry}
                placeholder="Select Expiry"
                styles={{
                  ...DropDownStylesBroker,
                  ...DropDownStylesBroker,
                  indicatorSeparator: (provided: any) => ({
                    ...provided,
                    display: "none",
                  }),
                  dropdownIndicator: (base: any) => ({
                    ...base,
                    color: "inherit",
                    padding: "0",
                    minHeight: "auto",
                    maxHeight: "auto",
                    "&:hover": {
                      color: "inherit",
                    },
                  }),
                  indicatorsContainer: (provided: any) => ({
                    ...provided,
                  }),
                  menuList: (base: any) => ({
                    ...base,
                    padding: 0,
                    backgroundColor: "var(--color-white)",
                    boxShadow: "0px 3px 6px rgba(var(--color-black-rgb), 0.25) !important",
                    border: "none",
                    color: "var(--primaryText)",
                    borderRadius: 0,
                    cursor: "pointer",
                    maxHeight: "80px",
                    overflowY: "auto",
                  }),
                }}
              />
            </div>
          </div>
          <div>
            {["CALL", "PUT"].map((contract, index) => (
              <li
                key={contract}
                onClick={() => {
                  setConValue({
                    ContractId: `${data.Value.sec}${selectedExpiry?.value}${contract?.slice(0, 1)}${selectedStrike?.value}`,
                    Exchange: selectedExchange?.Exchange,
                    Expiration: selectedExpiry?.value,
                    Multiplier: selectedExchange?.Multiplier,
                    RightType: contract,
                    Strike: selectedStrike?.value,
                    TradingClass: data.Value.sec,
                    DisplaySecurity: `${data.Value.sec} | ${selectedExchange?.Exchange} | ${selectedStrike?.value} | ${selectedExpiry?.value} | ${contract}`,
                  });
                  handleSelectFuture(contract);
                  localStorage.setItem("current_market_id", "7");
                  // dispatch(update_form_data({ vendor: 2 }));
                  onClose();
                }}
                className={classNames("border list-none hover:bg-[#B0CCF352]")}
              >
                <div className="text-[0.75rem] leading-[1.25] text-[#a4a3a3] px-[0.6vw] py-[0.42vw] flex justify-start items-start cursor-pointer">
                  {`${data.Value.sec} | ${selectedExchange.Exchange} | ${selectedStrike?.value} | ${selectedExpiry?.value} | ${contract}`}
                </div>
              </li>
            ))}
          </div>
        </div>
      ) : (
        <div className="text-center text-sm text-gray-500">No options securities found.</div>
      )}
    </>
  );
};

export default OptionSelector;
